import React, { useState, useEffect, useRef, useCallback } from "react";
import { getLocationByLatLang } from "../../Utils/utils/CommanFnc";

export function GoogleMap(props) {
  const [lat, lng] = props.data?.latLng?.split(',')
  const readOnly = props.data?.readOnly
  const [center, setCenter] = useState({});
  const zoom = 13;
  const [display, setDisplay] = useState("");
  const inputEl = useRef();
  const [latLang, setLatLang] = useState({})
  const [address, setAddress] = useState("")

  function success(pos) {
    const crd = pos.coords;
     setCenter({ lat: parseFloat(crd.latitude), lng: parseFloat(crd.longitude) })
  }
  
  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  const getCurrentLocation = useCallback( ()=>{
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    if(lat && lng){
      setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) })
    }else{
      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  },[lat, lng])  

  function renderInfoWindow({marker, place, map, infowindow, infowindowContent}) {
    setLatLang(place.geometry.location.toJSON())

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }
    // Set the position of the marker using the place ID and location.
    // @ts-ignore This should be in @typings/googlemaps.
    marker.setPosition(place.geometry.location);
    marker.setVisible(true);
    setAddress(place.formatted_address)
    infowindowContent.children.namedItem("place-name").textContent = place?.name || place?.address_components?.[0]?.['long_name']
    infowindowContent.children.namedItem("place-address").textContent = place.formatted_address;
    infowindow.open(map, marker);
  }
  const initMap = useCallback( () => {
  
      try{
      
        const map = new window.google.maps.Map(inputEl.current, {
          center,
          zoom,
          mapTypeId: window.google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          navigationControlOptions: { 
            style: window.google.maps.NavigationControlStyle.SMALL 
          }
        });
  
        const markerOpt = {
          position: center, 
          map: map, 
          animation: window.google.maps.Animation.DROP,
          draggable: true,
          cursor: 'drag',
        } 
  
        const input = document.getElementById("pac-input");
        // Specify just the place data fields that you need.
        const autocomplete = new window.google.maps.places.Autocomplete(input, {
          fields: ["place_id", "geometry", "formatted_address", "name"],
        });
  
        autocomplete.bindTo("bounds", map);
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);
  
        const infowindow = new window.google.maps.InfoWindow();
        const infowindowContent = document.getElementById("infowindow-content");
  
        infowindow.setContent(infowindowContent);
        const marker = new window.google.maps.Marker(markerOpt);
  
        marker.addListener("click", () => {
          infowindow.open(map, marker);
        });
  
        const lat =  marker.getPosition()?.lat()
        const lng =  marker.getPosition()?.lng()
  
        if(lat && lng){
          getLocationByLatLang({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()}).then((place)=>{
            renderInfoWindow({marker, place, map, infowindow, infowindowContent})
          })
        }
  
        window.google.maps.event.addListener(marker, 'dragend', function () {
            getLocationByLatLang({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()}).then((place)=>{
              renderInfoWindow({marker, place, map, infowindow, infowindowContent})
            })
        });
  
  
        autocomplete.addListener("place_changed", () => {
          infowindow.close();
          const place = autocomplete.getPlace();
          if (!place.geometry || !place.geometry.location) {
            return;
          }
          renderInfoWindow({marker, place, map, infowindow, infowindowContent})
        });
      }catch(error){
        console.log(error)
      }
  },[center])

  useEffect(() => {
    setDisplay("block")
  }, [])

  const setLatLong = ()=>{
      if(latLang.hasOwnProperty("lat") && latLang.hasOwnProperty("lng")){
        props.setLocationData({...latLang, address})
        props.openMap()
        setDisplay("none")  
      }
  }

  useEffect(() => {
    setTimeout(()=>{
      getCurrentLocation()
    },100)
  }, [getCurrentLocation]);

  useEffect(() => {
    setTimeout(()=>{
      initMap()
    }, 100)
  }, [center, initMap]);

  const btnEventHandel = () => {
    setDisplay("none")
    props.openMap()
  }
  return (
    <div className="modal fade model-lg show" style={{ "display": display }}>
      <div className="modaloverlay show"></div>
      <div className="row">
        <div className="col-sm-12 mx-auto">
          <div className="panel mui-panel mui--z4 animated fadeInRight pl-4 pr-4 pt-0 pb-0">
          <>
                <div className="row">
                  <div className="col-sm-12 p-2 d-flex align-items-end" id="pac-card" style={{ background: "#fff"}}>
                    <div className="col-sm-6 p-0 form-group mb-3">
                      {/* <label className={`d-block`}>
                        Autocomplete search
                      </label> */}
                      <input  
                          value={address}
                          className="input-txt form-control" 
                          id="pac-input" 
                          type="text" 
                          disabled={readOnly}
                          placeholder="Enter a location" 
                          onChange={(e)=>setAddress(e.target.value)}
                      />
                    </div>
                    {
                      !readOnly?<button type="button" onClick={setLatLong} className="btn-success mb-3 ml-3">Go</button>:''
                    }
                    &nbsp;
                    <button type="button" onClick={btnEventHandel} className="btn-danger mb-3">Close</button>
                  </div>
                </div>
                <div className="row p-3">
                  <div ref={inputEl} id="map" className="col-sm-12" style={{
                    width: "100%",
                    height: "calc(100vh - 150px)"
                  }} />
                <div id="infowindow-content">
                  <span id="place-name" className="title"></span><br />
                  <span id="place-address"></span>
                </div>
                </div>
              </>
          </div>
        </div>
      </div>
    </div>
  );
}